<h4 class="title ms-2">Hashtags</h4>
<div class="create-field">
  <div class="hashtag-form-and-buttons-container">
    <app-filled-form-field class="hashtag-input-form"
                           [label]="'Name'"
                           [formControl]="hashtagControl"
                           [isControlInvalid]="(!hashtagControl.valid && hashtagControl.touched) || errorMessage != null"
                           [errorMessage]="!hashtagControl.valid && hashtagControl.touched ? HASH_TAG_ERROR_SIZE_MESSAGE : errorMessage">
    </app-filled-form-field>
    <div class="buttons-side">
      <button mat-button class="cancel-btn" (click)="resetForm()">Undo</button>
      <button mat-button class="save-btn" (click)="generateTag()">
        <div class="admin-add-icon-and-text">
          <mat-icon class="add-icon-hashtag">add</mat-icon>
          Create
        </div>
      </button>
    </div>
  </div>
</div>
<div class="hashtags-container">
  <div class="hashtag-list-collection">
    <div class="hashtag-content-list">
      <div class="hashtags-info-container hashtag-info-text">
        Hashtags info
      </div>
      <div class="line-container"></div>
      <p-table class="w-100 mt-1 transaction-table table-bordered" [value]="hashtags"
               [tableStyle]="{'min-width': '60rem'}"
               [paginator]="false"
               [rowHover]="true"
               [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
            <th class="bg-light-white text-center">#</th>
            <th class="bg-light-white text-center">Name</th>
            <th class="bg-light-white text-center">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr>
            <td class="text-center">
              {{ (currentPage * pageSize) + rowIndex + 1 }}
            </td>
            <td class="d-flex justify-content-center">
              <div class="hashtag-name-container">
                <div class="hashtag-name-text-container">
                  <div>
                    {{ row.name }}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="list-for-edit text-center">
                <img src="assets/svg/deleteHashtagButton.svg" (click)="deleteHashtag(row)">
              </div>
            </td>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="no-data">No data to display.</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="pagination">
        <a (click)="goToPage(currentPage - 1)" [class.disabled]="currentPage === 0">&laquo;</a>
        <a *ngFor="let page of getPageNumbers()"
           (click)="goToPage(page - 1)"
           [class.active]="currentPage === (page - 1)">
          {{ page }}
        </a>
        <a (click)="goToPage(currentPage + 1)" [class.disabled]="currentPage == Math.ceil(this.totalHashtagSize / this.pageSize - 1)">&raquo;</a>
      </div>
    </div>
  </div>
</div>
